import { requireUser } from '~/apps/shared/permissions';
import { UserRole } from '~/apps/shared/consts';

// Pages
import PaycodeList from './pages/PaycodeList';
import PaycodeCreate from './pages/PaycodeCreate';
import PaycodeConfirm from './pages/PaycodeConfirm';
import PaycodeInfo from './pages/PaycodeInfo';
import PaycodeEdit from './pages/PaycodeEdit';

import TransactionList from './pages/TransactionList';
import TransactionReceipt from './pages/TransactionReceipt';

import SettingsAccount from './pages/SettingsAccount';
import SettingsSupport from './pages/SettingsSupport';
import SettingsLegal from './pages/SettingsLegal';

import SettingsTeam from './pages/SettingsTeam';
import SettingsTeamCreate from './pages/SettingsTeamCreate';
import SettingsTeamEdit from './pages/SettingsTeamEdit';

import OrgLocationList from './pages/OrgLocationList';
import OrgLocationCreate from './pages/OrgLocationCreate';
import OrgLocationEdit from './pages/OrgLocationEdit';

import Logout from "~/apps/shared/pages/Logout";


// Client-side routes
export const appRoutes = [
  {
    name: 'sender',
    path: '/sender',
    forwardTo: 'sender.paycodes',
    canActivate: requireUser(),
    children: [
      {
        name: 'paycodes',
        path: '/codes?q',
        comp: PaycodeList,
        children: [
          {
            name: 'create',
            path: '/create',
            comp: PaycodeCreate,
          },
          {
            name: 'confirm',
            path: '/confirm/:paycodeId',
            comp: PaycodeConfirm,
          },
          {
            name: 'info',
            path: '/info/:paycodeId',
            comp: PaycodeInfo,
          },
          {
            name: 'edit',
            path: '/edit/:paycodeId',
            comp: PaycodeEdit,
          },
        ],
      },
      {
        name: 'transactions',
        path: '/transactions?q',
        comp: TransactionList,
        children: [
          {
            name: 'receipt',
            path: '/receipt/:transactionId',
            comp: TransactionReceipt,
          }
        ],
      },
      {
        name: 'settings',
        path: '/settings',
        forwardTo: 'sender.settings.account',
        comp: SettingsAccount,
        children: [
          {
            name: 'account',
            path: '/account',
            comp: SettingsAccount,
          },
          {
            name: 'team',
            path: '/team?q',
            comp: SettingsTeam,
            children: [
              {
                name: 'create',
                path: '/create',
                comp: SettingsTeamCreate,
              },
              {
                name: 'edit',
                path: '/edit/:userId',
                comp: SettingsTeamEdit,
              },
            ],
          },
          {
            name: 'support',
            path: '/support',
            comp: SettingsSupport,
          },
          {
            // TODO
            name: 'legal',
            path: '/legal',
            comp: SettingsLegal,
          },
          {
            name: 'logout',
            path: '/logout',
            comp: Logout,
          }
        ],
      },
      {
        name: 'locations',
        path: '/locations',
        comp: OrgLocationList,
        children: [
          {
            name: 'create',
            path: '/create',
            comp: OrgLocationCreate,
          },
          {
            name: 'edit',
            path: '/edit/:locationId',
            comp: OrgLocationEdit,
          },
        ],
      },
    ]
  }
];
